import React from 'react';
import { Form, TimePicker } from 'antd';

//https://ant.design/components/time-picker
const FormTime = ({ label, name, rules, inline = false, ...rest }) => {
  const timeFormat = rest?.format ?? 'H:mm';

  // Inline/standalone variant for use outside of Form layouts (e.g., toolbars/modals footers)
  if (inline) {
    return (
      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
        {label ? <span style={{ whiteSpace: 'nowrap' }}>{label}</span> : null}
        <TimePicker {...rest} format={timeFormat} />
      </div>
    );
  }

  // Default variant for use inside antd Form
  return (
    <Form.Item label={label} name={name} rules={rules}>
      <TimePicker {...rest} format={timeFormat} />
    </Form.Item>
  );
};

export default FormTime;
